/**
 * Context global de Transportadora selecionada.
 * - Persiste em localStorage
 * - Sincroniza com api interceptor (em lib/ocorenApi.js)
 */
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setTransportadoraCnpj, getTransportadoraCnpj } from "@/lib/ocorenApi";

const TransportadoraContext = createContext(null);
const STORAGE_KEY = "ocoren.transp.cnpj";

export const TransportadoraProvider = ({ children }) => {
  // Lê o valor inicial do mesmo lugar que lib/ocorenApi já leu (síncrono)
  const [selectedCnpj, setSelectedCnpjState] = useState(() => getTransportadoraCnpj());
  const [transportadoras, setTransportadoras] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/ocoren/transportadoras");
      setTransportadoras(res.data?.items || []);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setSelectedCnpj = useCallback((cnpj) => {
    const value = cnpj || "";
    setSelectedCnpjState(value);
    setTransportadoraCnpj(value);   // atualiza o interceptor imediatamente
    try {
      if (value) localStorage.setItem(STORAGE_KEY, value);
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* localStorage indisponível, ignorar */
    }
  }, []);

  const selectedTransp = transportadoras.find((t) => t.cnpj === selectedCnpj) || null;

  return (
    <TransportadoraContext.Provider
      value={{
        selectedCnpj,
        setSelectedCnpj,
        selectedTransp,
        transportadoras,
        loading,
        refresh,
      }}
    >
      {children}
    </TransportadoraContext.Provider>
  );
};

export const useTransportadora = () => {
  const ctx = useContext(TransportadoraContext);
  if (!ctx) throw new Error("useTransportadora deve estar dentro de TransportadoraProvider");
  return ctx;
};

export const formatCNPJ = (cnpj) => {
  if (!cnpj) return "—";
  const c = String(cnpj).replace(/\D/g, "");
  if (c.length !== 14) return cnpj;
  return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12, 14)}`;
};
